// Import pages
import Header from './LandingPage/header.svelte';
import Solution from './LandingPage/solution.svelte';
import whyGaming from './LandingPage/whyGaming.svelte';
import GamingImpact from './EveryGamer/everyGamer.svelte';
import Mission from './Mission.svelte';
import Outcomes from './outcome.svelte';
import Future from '/future.svelte';
import technology from './technologyReadniss/technology.svelte';
import VideoGaming from './videoGaming.svelte';
import FutureOfGaming from './futureOfGaming.svelte';
import OpusWeb3 from './opusWeb3/opusWeb3.svelte';
import Moat from './moat/moat.svelte';
import Joinus from './moat/joinus.svelte';
import Questions from './moat/questions.svelte';
import ourTeam from './ourTeam.svelte';
import roadMap from './Roadmap/roadmap.svelte';
import traction from './Traction/traction.svelte';
import Problem from './LandingPage/newProblem.svelte';
import Sustainability from './opusWeb3/sustainability.svelte';
export default {
// Put pages here
    '/': Header,
    '/problem': Problem,
    '/whygaming': whyGaming,
    '/solution': Solution,
    '/gamingImpact': GamingImpact,
    '/videoGaming': VideoGaming,
    '/futureOfGaming': FutureOfGaming,
    '/opusWeb3': OpusWeb3,
    '/sustainability': Sustainability,
    '/traction': traction,
    '/mission': Mission,
    '/outcomes': Outcomes,
    '/future': Future,
    '/technology': technology,
    '/roadmap': roadMap,
    '/moat': Moat,
    '/ourTeam': ourTeam,
    '/joinus': Joinus,
    '/questions': Questions,

};
